import {useState, useEffect,useContext} from 'react'
import { UserStoreContext } from '../Contexts/UserStoreContext';
import Axios from 'axios';
import ENVIROMENTS from '../Environment/Configuration.json';

const useFetch = (request) => {
    const [data, setData] = useState(null);
    const[isLoading, setIsLoading] = useState(true);
    const[error, setError] = useState(null);
    
    
    const {is_logged_in, user_store} = useContext(UserStoreContext)

    useEffect(()=>{ 
        setData(null)
        setError(null);  
        setIsLoading(true)

        if(request){
            const url = ENVIROMENTS.baseUrl + '/geniuxmusic/api/facebook/get_page_posts.php';
            let cancel
            Axios({
                method: 'post',
                url: url,
                data: {
                    user_id: ""
                },
                cancelToken: new Axios.CancelToken(c => cancel = c),

            })
            
            .then(response=>{
                setIsLoading(false)
                if(response.data && response.data.data.length>0){
                    setData(response.data)
         
                }else{
                    setError('no_results')
                  
                }
        
            
            })
            .catch(err=>{
                if(!Axios.isCancel(err)){
                    setError('network_err');
                    setIsLoading(false)
                }
            })
            return () => cancel()
        }
     
    },[request])
 
    return {data, isLoading, error}
}

export default useFetch
